import React, { useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';

// Mobile navigation drawer. Opens from the header hamburger below 900px.
// Escape closes, the scrim closes, selecting an item navigates + closes, and
// body scroll is locked while open. (Full focus-trap is a Phase 4 a11y item.)
export default function NavDrawer({ open, onClose, meeting, navItems, days }) {
  const closeBtnRef = useRef(null);
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') { onClose(); return; }
      // Focus trap: keep Tab focus cycling inside the drawer while it's open.
      if (e.key === 'Tab' && panelRef.current) {
        const f = panelRef.current.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        const first = f[0];
        const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeBtnRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="portal-drawer-overlay" role="dialog" aria-modal="true" aria-label="Menu">
      <button
        type="button"
        className="portal-drawer-scrim"
        aria-label="Close menu"
        onClick={onClose}
      />
      <div className="portal-drawer-panel" ref={panelRef}>
        <div className="portal-drawer-head">
          <div>
            <div className="portal-drawer-eyebrow">{meeting.org} 2026</div>
            <div className="portal-drawer-title">Menu</div>
          </div>
          <button
            type="button"
            className="portal-drawer-close"
            onClick={onClose}
            aria-label="Close menu"
            ref={closeBtnRef}
          >
            <Icon name="x" size={22} />
          </button>
        </div>

        <nav className="portal-drawer-nav">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              className={({ isActive }) => `portal-drawer-item${isActive ? ' active' : ''}`}
              onClick={onClose}
            >
              <span className="portal-nav-index">{it.n}</span>
              <span className="portal-nav-label">{it.name}</span>
              {it.count != null && <span className="portal-nav-count">{it.count}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="portal-drawer-foot">
          <span>{days} {days === 1 ? 'day' : 'days'} out</span>
          <NavLink to="/" className="portal-drawer-exit" onClick={onClose}>Exit</NavLink>
        </div>
      </div>
    </div>
  );
}
